import passport from './interfaces/passport';
import unifydata from './interfaces/unifydata';
import digitalBook from './interfaces/digitalBook';
import accounts from './interfaces/accounts';
import payorder from './interfaces/payorder';

export default {
    passport,
    unifydata,
    digitalBook,
    accounts,
    payorder
}